import { TypographyP } from "@/components/ui/typography";
import { format as formatDate } from "date-fns";

type Props = {
  value: Date;
  format?: string;
  className?: string;
};

export const DateCell = ({
  value,
  format = "dd.MM.yyyy HH:mm",
  className,
}: Props) => {
  const date = new Date(value);

  return (
    <TypographyP className={className}>{formatDate(date, format)}</TypographyP>
  );
};
